import Text from 'components/elements/text';
import { FullContainer, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import ProductVariantTable from './table';

export default function ProductVariantField() {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <Text variant="HeadingXSmall">{t('common:product_variant')}</Text>
      <SeparatorVertical $margin={24} />
      <ProductVariantTable />
    </FullContainer>
  );
}
